var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3329 9.66669H5.43957L11.9462 3.16003C12.4662 2.64003 12.4662 1.78669 11.9462 1.26669C11.8229 1.14309 11.6764 1.04503 11.5151 0.978118C11.3538 0.91121 11.1809 0.87677 11.0062 0.87677C10.8316 0.87677 10.6587 0.91121 10.4974 0.978118C10.3361 1.04503 10.1896 1.14309 10.0662 1.26669L1.27957 10.0534C1.15597 10.1767 1.05791 10.3232 0.990997 10.4845C0.924089 10.6458 0.889648 10.8187 0.889648 10.9934C0.889648 11.168 0.924089 11.3409 0.990997 11.5022C1.05791 11.6635 1.15597 11.81 1.27957 11.9334L10.0662 20.72C10.1897 20.8435 10.3362 20.9414 10.4975 21.0082C10.6588 21.075 10.8317 21.1094 11.0062 21.1094C11.1808 21.1094 11.3537 21.075 11.515 21.0082C11.6763 20.9414 11.8228 20.8435 11.9462 20.72C12.0697 20.5966 12.1676 20.45 12.2344 20.2888C12.3012 20.1275 12.3356 19.9546 12.3356 19.78C12.3356 19.6055 12.3012 19.4326 12.2344 19.2713C12.1676 19.11 12.0697 18.9635 11.9462 18.84L5.43957 12.3334H20.3329C21.0662 12.3334 21.6662 11.7334 21.6662 11C21.6662 10.2667 21.0662 9.66669 20.3329 9.66669Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.acf38ea95cda71b8806a66f41ea61246.svg";
export { ForwardRef as ReactComponent };